import axios from "axios";
import {
	GET_POSTS,
	NUMBER_OF_LIKES,
	GET_PERSONAL_POSTS,
	GET_PERSONAL_VIDEOS,
	// IMG_UPLOADED,
	IMG_UPLOADING,
	GET_VIDEO,
	POST_LOADING
} from "./types";
import { createMessage } from "./messages";

let limit = 0;

// Get Text Posts
export const getPosts = (postStartValue) => (dispatch, getState) => {
	const key = getState().auth.key;

	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};

	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	const textPosts = axios.get(
		`https://api.whipafrica.com/v1/posts/feed/text/?start=${postStartValue}`,
		config
	);
	const imagePosts = axios.get(
		`https://api.whipafrica.com/v1/posts/feed/image/?start=${postStartValue}`,
		config
	);
	const videoPosts = axios.get(
		`https://api.whipafrica.com/v1/posts/feed/video/?start=${postStartValue}`,
		config
	);

	axios
		.all([textPosts, imagePosts, videoPosts])
		.then(
			axios.spread((...responses) => {
				const textRes = responses[0].data.results;
				const imageRes = responses[1].data.results;
				const videoRes = responses[2].data.results;
				dispatch({
					type: GET_POSTS,
					payload: textRes.concat(imageRes).concat(videoRes),
					vids: videoRes
				});
				console.log(videoRes.video_url);
			})
		)
		.catch((err) => {
			console.log(err?.response);
		});
};

export const postLoader = (bool) => {
	return (dispatch) => {
		dispatch({
			type: POST_LOADING,
			payload: bool
		});
	};
};

export const getAllPosts = () => (dispatch, getState) => {
	const key = getState().auth.key;
	dispatch(postLoader(true));

	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};

	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	if (limit <= 100) {
		limit = limit + 5;
	}
	axios
		.get(`https://api.whipafrica.com/v1/posts/feed/all/?limit=${limit}`, config)
		.then((res) => {
			dispatch(postLoader(false));
			dispatch({
				type: GET_POSTS,
				payload: res.data.results
			});
		})
		.catch((err) => {
			console.log(err?.response);
		});
};

export const getInitialPosts = (postStartValue, postLimit) => (dispatch, getState) => {
	const key = getState().auth.key;

	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};

	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	const textPosts = axios.get(
		`https://api.whipafrica.com/v1/posts/feed/text/?limit=${postLimit}&start=${postStartValue}`,
		config
	);
	const imagePosts = axios.get(
		`https://api.whipafrica.com/v1/posts/feed/image/?limit=${postLimit}&start=${postStartValue}`,
		config
	);
	const videoPosts = axios.get(
		`https://api.whipafrica.com/v1/posts/feed/video/?limit=${postLimit}&start=${postStartValue}`,
		config
	);

	axios
		.all([textPosts, imagePosts, videoPosts])
		.then(
			axios.spread((...responses) => {
				const textRes = responses[0].data.results;
				const imageRes = responses[1].data.results;
				const videoRes = responses[2].data.results;
				dispatch({
					type: GET_POSTS,
					payload: textRes.concat(imageRes).concat(videoRes),
					vids: videoRes
				});
				console.log(videoRes.video_url);
			})
		)
		.catch((err) => {
			console.log(err?.response);
		});
};
// Get Likes
export const getLikes = () => (dispatch, getState) => {
	const key = getState().auth.key;

	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	axios
		.get("https://api.whipafrica.com/v1/posts/text/likes/", config)
		.then((res) => {
			dispatch({
				type: NUMBER_OF_LIKES,
				payload: res.data
			});
		})
		.catch((err) => console.log(err?.response));
};
export const postTextLike = (postId) => (dispatch, getState) => {
	const key = getState().auth.key;

	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	axios
		.post(`https://api.whipafrica.com/v1/posts/text/like/${postId}/`, {}, config)
		.then((res) => {
			console.log(res);
		})
		.catch((err) => console.log(err?.response));
};
export const postImageLike = (postId) => (dispatch, getState) => {
	const key = getState().auth.key;

	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	axios
		.post(`https://api.whipafrica.com/v1/posts/image/like/${postId}/`, {}, config)
		.then((res) => {
			console.log(res);
		})
		.catch((err) => console.log(err?.response));
};
export const postVideoLike = (postId) => (dispatch, getState) => {
	const key = getState().auth.key;

	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	axios
		.post(`https://api.whipafrica.com/v1/posts/video/like/${postId}/`, {}, config)
		.then((res) => {
			console.log(res);
		})
		.catch((err) => console.log(err?.response));
};
// GET PERSONAL POSTS
export const getPersonalPosts = () => (dispatch, getState) => {
	const key = getState()?.auth?.key;
	const userId = getState()?.auth?.me[0]?.id;
	console.log(getState()?.auth?.me[0]?.id);

	//Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	const textPosts = axios.get(`https://api.whipafrica.com/v1/posts/feed/text/${userId}/`, config);
	const imagePosts = axios.get(`https://api.whipafrica.com/v1/posts/feed/image/${userId}/`, config);
	const videoPosts = axios.get(`https://api.whipafrica.com/v1/posts/feed/video/${userId}/`, config);

	axios
		.all([textPosts, imagePosts, videoPosts])
		.then(
			axios.spread((...responses) => {
				const textRes = responses[0].data.results;
				const imageRes = responses[1].data.results;
				const videoRes = responses[2].data.results;
				dispatch({
					type: GET_PERSONAL_POSTS,
					payload: textRes.concat(imageRes).concat(videoRes)
				});
			})
		)
		.catch((err) => {
			console.log(err?.response);
		});
};
export const getPersonalVideos = () => (dispatch, getState) => {
	const key = getState()?.auth?.key;
	const userId = getState()?.auth?.me[0]?.id;

	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	axios
		.get(`https://api.whipafrica.com/v1/posts/feed/video/${userId}/`, config)
		.then((res) => {
			dispatch({
				type: GET_PERSONAL_VIDEOS,
				payload: res.data.results
			});
			console.log(res.data.results);
		})
		.catch((err) => console.log(err?.response));
};
export const postText = (text_body) => (dispatch, getState) => {
	const key = getState().auth.key;

	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	const body = JSON.stringify({ text_body });
	const textPosts = axios.get("https://api.whipafrica.com/v1/posts/feed/text/", config);
	const imagePosts = axios.get("https://api.whipafrica.com/v1/posts/feed/image/", config);
	const videoPosts = axios.get("https://api.whipafrica.com/v1/posts/feed/video/", config);
	const postText = axios.post(
		`https://api.whipafrica.com/v1/posts/text/new-text-post/`,
		body,
		config
	);

	axios
		.all([textPosts, imagePosts, videoPosts, postText])
		.then(
			axios.spread((...responses) => {
				const textRes = responses[0].data.results;
				const imageRes = responses[1].data.results;
				const videoRes = responses[2].data.results;

				dispatch({
					type: GET_POSTS,
					payload: textRes.concat(imageRes).concat(videoRes)
				});
				dispatch(createMessage("Post Created Successfully"));
			})
		)
		.catch((err) => console.log(err?.response));
};
export const startPost = () => (dispatch, getState) => {
	dispatch({ type: IMG_UPLOADING });
};
export const postImage = (image_url, caption) => (dispatch, getState) => {
	const key = getState().auth.key;

	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	const body = JSON.stringify({ image_url, caption });
	const textPosts = axios.get("https://api.whipafrica.com/v1/posts/feed/text/", config);
	const imagePosts = axios.get("https://api.whipafrica.com/v1/posts/feed/image/", config);
	const videoPosts = axios.get("https://api.whipafrica.com/v1/posts/feed/video/", config);
	const postImage = axios.post(
		"https://api.whipafrica.com/v1/posts/image/new-image-post/",
		body,
		config
	);
	axios
		.all(textPosts, imagePosts, videoPosts, postImage)
		.then(
			axios.spread((...responses) => {
				const textRes = responses[0].data.results;
				const imageRes = responses[1].data.results;
				const videoRes = responses[2].data.results;
				dispatch({
					type: GET_POSTS,
					payload: textRes.concat(imageRes).concat(videoRes)
				});
			})
		)
		.catch((err) => console.log(err?.response));
};
export const postVideo = (video_url, caption) => (dispatch, getState) => {
	const key = getState().auth.key;

	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	const body = JSON.stringify({ video_url, caption });

	const textPosts = axios.get("https://api.whipafrica.com/v1/posts/feed/text/", config);
	const imagePosts = axios.get("https://api.whipafrica.com/v1/posts/feed/image/", config);
	const videoPosts = axios.get("https://api.whipafrica.com/v1/posts/feed/video/", config);
	const postVideo = axios.post(
		"https://api.whipafrica.com/v1/posts/video/new-video-post/",
		body,
		config
	);
	axios
		.all([textPosts, imagePosts, videoPosts, postVideo])
		.then(
			axios.spread((...responses) => {
				const textRes = responses[0].data.results;
				const imageRes = responses[1].data.results;
				const videoRes = responses[2].data.results;
				dispatch({
					type: GET_POSTS,
					payload: textRes.concat(imageRes).concat(videoRes)
				});
			})
		)
		.catch((err) => console.log(err?.response));
};

export const getVideos = () => (dispatch, getState) => {
	const key = getState().auth.key;
	const userId = getState()?.auth?.me[0]?.id;

	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	axios
		.get(`https://api.whipafrica.com/v1/posts/feed/video/`, config)
		.then((res) => {
			// console.log(res,'getVideo')

			dispatch({
				type: GET_VIDEO,
				payload: res.data.results
			});
			console.log(res.data.results);
		})
		.catch((err) => console.log(err?.response));
};
